import React from "react";
import { Card, CardContent } from "./ui/card";
import { Button } from "./ui/button";
import { GraduationCap, Building2, ArrowRight } from "lucide-react";
import { mockData } from "../mock";

const MentorPartnerSection = () => {
  const { mentorPartner } = mockData;

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          {/* Clean Header - Welcome.com Style */}
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
            Join Our
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-blue-600"> 
              {" "}Expert Network
            </span>
          </h2>
          
          {/* Professional Subtitle */}
          <p className="text-xl md:text-2xl text-gray-600 max-w-4xl mx-auto mb-8 leading-relaxed font-medium">
            Share your expertise and amplify your impact by guiding the next generation of conscious businesses
          </p>
          
          <div className="w-24 h-1 bg-gradient-to-r from-purple-500 to-blue-500 mx-auto rounded-full"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto mb-16">
          {/* Mentors Card */}
          <Card className="group hover:shadow-lg transition-all duration-300 border-0 bg-gradient-to-br from-purple-50/50 to-purple-100/50 p-8">
            <CardContent className="p-0">
              <div className="w-16 h-16 mb-6 rounded-2xl bg-gradient-to-br from-purple-500 to-purple-600 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                <GraduationCap className="h-8 w-8 text-white" />
              </div>
              
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Become a Mentor
              </h3>
              
              <p className="text-gray-600 mb-8 leading-relaxed">
                Guide emerging conscious businesses with your expertise. Share knowledge, build connections, and shape the future of sustainable business.
              </p>

              <a href="/mentor-partner">
                <Button className="w-full bg-gradient-to-r from-purple-500 to-purple-600 text-white hover:from-purple-600 hover:to-purple-700 transition-all duration-300 font-semibold">
                  Apply as Mentor
                  <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
              </a>
            </CardContent>
          </Card>

          {/* Partners Card */}
          <Card className="group hover:shadow-lg transition-all duration-300 border-0 bg-gradient-to-br from-blue-50/50 to-blue-100/50 p-8">
            <CardContent className="p-0">
              <div className="w-16 h-16 mb-6 rounded-2xl bg-gradient-to-br from-blue-500 to-blue-600 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                <Building2 className="h-8 w-8 text-white" />
              </div>
              
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Strategic Partnerships
              </h3>
              
              <p className="text-gray-600 mb-8 leading-relaxed">
                Collaborate with CNESS to expand your impact. Access our global network and co-create solutions for sustainable business transformation.
              </p>

              <a href="/mentor-partner">
                <Button className="w-full bg-gradient-to-r from-blue-500 to-blue-600 text-white hover:from-blue-600 hover:to-blue-700 transition-all duration-300 font-semibold">
                  Explore Partnership
                  <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
              </a>
            </CardContent>
          </Card>
        </div>

        {/* Clean CTA Section */}
        <div className="text-center bg-gradient-to-r from-gray-50 to-gray-100/50 rounded-2xl p-8 max-w-4xl mx-auto">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">
            Ready to Make a Difference?
          </h3>
          <p className="text-gray-600 mb-6 leading-relaxed max-w-3xl mx-auto">
            Join our community of sustainability leaders and help shape the future of conscious business practices.
          </p>
          <a href="/mentor-partner">
            <Button 
              size="lg"
              className="bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-700 hover:to-blue-700 text-white px-8 py-4 text-lg font-semibold shadow-lg hover:shadow-xl transition-all duration-300"
            >
              Join the Network
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default MentorPartnerSection;